/**
 * Module to show Recently Viewed Products
 *
 * Copyright (c) 2014 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */
import {formatMoney} from '@shopify/theme-currency';
import {getSizedImageUrl} from '@shopify/theme-images';

import showElement from '../util/show-element';

Shopify.Products = (function () {
  const config = {
    howManyToShow: 4,
    howManyToStoreInMemory: 10,
    wrapperId: 'recently-viewed-products',
    templateId: 'recently-viewed-product-template',
    onComplete: null,
  };

  let productHandleQueue = [];
  let wrapper = null;
  let template = null;
  let howManyToShowItems = null;

  const cookie = {
    configuration: {
      expires: 90,
      path: '/',
      domain: window.location.hostname,
    },
    name: 'shopify_recently_viewed',
    write: function (recentlyViewed) {
      const recentlyViewedString = recentlyViewed.join(' ');
      document.cookie = `${this.name}=${recentlyViewedString}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
    },
    read: function () {
      let recentlyViewed = [];
      let cookieValue = null;
      const templateProduct = document.querySelector('#template-product');

      if (templateProduct) {
        const currentProduct = templateProduct.getAttribute('data-product-handle');

        if (document.cookie.indexOf('; ') !== -1 && document.cookie.split('; ').find((row) => row.startsWith(this.name))) {
          cookieValue = document.cookie
            .split('; ')
            .find((row) => row.startsWith(this.name))
            .split('=')[1];
        }

        if (cookieValue !== null) {
          recentlyViewed = cookieValue.split(' ');
        }

        // Remove current product from the array
        if (recentlyViewed.indexOf(currentProduct) != -1) {
          const currentProductIndex = recentlyViewed.indexOf(currentProduct);
          recentlyViewed.splice(currentProductIndex, 1);
        }
      }

      return recentlyViewed;
    },
    destroy: function () {
      const cookieVal = null;
      document.cookie = `${this.name}=${cookieVal}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
    },
    remove: function (productHandle) {
      const recentlyViewed = this.read();
      const position = recentlyViewed.indexOf(productHandle);
      if (position !== -1) {
        recentlyViewed.splice(position, 1);
        this.write(recentlyViewed);
      }
    },
  };

  const finalize = () => {
    showElement(wrapper, true);
    const cookieItemsLength = cookie.read().length;

    if (Shopify.recentlyViewed && howManyToShowItems && cookieItemsLength && cookieItemsLength < howManyToShowItems && wrapper.children.length) {
      let allClassesArr = [];
      let addClassesArr = [];
      let objCounter = 0;
      for (const property in Shopify.recentlyViewed) {
        objCounter += 1;
        const objString = Shopify.recentlyViewed[property];
        const objArr = objString.split(' ');
        const propertyIdx = parseInt(property.split('_')[1]);
        allClassesArr = [...allClassesArr, ...objArr];

        if (cookie.read().length === propertyIdx || (objCounter === Object.keys(Shopify.recentlyViewed).length && !addClassesArr.length)) {
          addClassesArr = [...addClassesArr, ...objArr];
        }
      }

      for (let i = 0; i < wrapper.children.length; i++) {
        const element = wrapper.children[i];
        if (allClassesArr.length) {
          element.classList.remove(...allClassesArr);
        }

        if (addClassesArr.length) {
          element.classList.add(...addClassesArr);
        }
      }
    }

    // If we have a callback.
    if (config.onComplete) {
      try {
        config.onComplete();
      } catch (error) {
        console.log('error');
      }
    }
  };

  const moveAlong = (shown) => {
    if (productHandleQueue.length && shown < config.howManyToShow) {
      fetch('/products/' + productHandleQueue[0] + '.js')
        .then((response) => response.json())
        .then((product) => {
          product.priceFormatted = formatMoney(product.price, theme.moneyFormat);
          product.compareFormatted = formatMoney(product.compare_at_price, theme.moneyFormat);
          product.topImage = product.media[0] ? getSizedImageUrl(product.media[0].preview_image.src, '900x900') : '';
          product.bottomImage = product.media[1] ? getSizedImageUrl(product.media[1].preview_image.src, '900x900') : '';

          let doubleImageClass = '';
          let bottomImageClass = '';
          let saleClass = 'is-hidden hidden';
          let priceClass = '';
          let fromClass = 'is-hidden hidden';

          if (product.media.length > 1) {
            doubleImageClass = 'double__image';
          } else {
            bottomImageClass = 'is-hidden hidden';
          }

          if (product.compare_at_price > product.price) {
            priceClass = 'sale';
            saleClass = '';
          }

          if (product.price_varies) {
            fromClass = '';
          }

          const stripHtmlRegex = /(<([^>]+)>)/gi;
          const productTitleStripped = product.title.replace(stripHtmlRegex, '');

          let markup = template.innerHTML;
          markup = markup.replace(/\|\|itemUrl\|\|/g, product.url);
          markup = markup.replace(/\|\|itemDoubleImageClass\|\|/g, doubleImageClass);
          markup = markup.replace(/\|\|itemTopImage\|\|/g, product.topImage);
          markup = markup.replace(/\|\|itemBottomImage\|\|/g, product.bottomImage);
          markup = markup.replace(/\|\|itemBottomImageClass\|\|/g, bottomImageClass);
          markup = markup.replace(/\|\|itemSaleClass\|\|/g, saleClass);
          markup = markup.replace(/\|\|itemPriceClass\|\|/g, priceClass);
          markup = markup.replace(/\|\|itemFromClass\|\|/g, fromClass);
          markup = markup.replace(/\|\|itemTitle\|\|/g, productTitleStripped);
          markup = markup.replace(/\|\|itemComparedPrice\|\|/g, product.compareFormatted);
          markup = markup.replace(/\|\|itemPrice\|\|/g, product.priceFormatted);
          markup = markup.replace(/\|\|itemHandle\|\|/g, product.handle);

          if (product.options[0].name === 'Title' && product.options.length === 1 && product.options[0].values[0] === 'Default Title') {
            markup = markup.replace(/\|\|itemHasOnlyDefault\|\|/g, 'data-quick-add-button');
          } else {
            markup = markup.replace(/\|\|itemHasOnlyDefault\|\|/g, '');
          }

          const colorArray = product.options.filter((option) => {
            for (let index = 0; index < theme.swatchLabels.length; index++) {
              const label = theme.swatchLabels[index].trim();

              if (Object.values(option).includes(label)) {
                return option;
              }
            }
          });

          markup = markup.replace(/\|\|itemSwatchesHidden\|\|/g, colorArray.length > 0 ? '' : 'hide');
          markup = markup.replace(/\|\|itemColorLabel\|\|/g, colorArray.length > 0 ? colorArray[0].name : '');

          wrapper.innerHTML += markup;

          productHandleQueue.shift();
          shown++;
          moveAlong(shown);
        })
        .catch(() => {
          cookie.remove(productHandleQueue[0]);
          productHandleQueue.shift();
          moveAlong(shown);
        });
    } else {
      finalize();
    }
  };

  return {
    showRecentlyViewed: function (params) {
      const paramsNew = params || {};
      const shown = 0;

      // Update defaults.
      Object.assign(config, paramsNew);

      // Read cookie.
      productHandleQueue = cookie.read();

      // Template and element where to insert.
      template = document.querySelector(`#${config.templateId}`);
      wrapper = document.querySelector(`#${config.wrapperId}`);

      // How many products to show.
      howManyToShowItems = config.howManyToShow;
      config.howManyToShow = Math.min(productHandleQueue.length, config.howManyToShow);

      // If we have any to show.
      if (config.howManyToShow && template && wrapper) {
        // Getting each product with an Ajax call and rendering it on the page.
        moveAlong(shown);
      }
    },

    getConfig: function () {
      return config;
    },

    clearList: function () {
      cookie.destroy();
    },

    recordRecentlyViewed: function (params) {
      const paramsNew = params || {};

      // Update defaults.
      Object.assign(config, paramsNew);

      // Read cookie.
      let recentlyViewed = cookie.read();

      // If we are on a product page.
      if (window.location.pathname.indexOf('/products/') !== -1) {
        // What is the product handle on this page.
        const productHandle = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
        // In what position is that product in memory.
        const position = recentlyViewed.indexOf(productHandle);
        // If not in memory.
        if (position === -1) {
          // Add product at the start of the list.
          recentlyViewed.unshift(productHandle);
          // Only keep what we need.
          recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
        } else {
          // Remove the product and place it at start of list.
          recentlyViewed.splice(position, 1);
          recentlyViewed.unshift(productHandle);
        }

        // Update cookie.
        cookie.write(recentlyViewed);
      }
    },

    hasProducts: cookie.read().length > 0,
  };
})();
